export default "__VITE_ASSET__B$5TXM6N__"